<template>
  <div class="profile">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row">
              <div class="col-sm-12">
                <h3 class="page-title">Profile</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item">
                    <router-link to="/index">Dashboard</router-link>
                  </li>
                  <li class="breadcrumb-item active">Profile</li>
                </ul>
              </div>
            </div>
          </div>
          <!-- /Page Header -->

          <div class="card mb-0">
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <div class="profile-view">
                    <div class="profile-img-wrap">
                      <div class="profile-img">
                        <a @click="openChangePhoto"
                          ><img
                            alt=""
                            :src="employee.passportPhoto"
                            v-if="employee.passportPhoto"/>
                          <img
                            alt=""
                            src="~@/assets/profiles/avatar-02.jpg"
                            v-if="!employee.passportPhoto"
                        /></a>
                      </div>
                    </div>
                    <div class="profile-basic">
                      <div class="row">
                        <div class="col-md-5">
                          <div class="profile-info-left">
                            <h3 class="user-name m-t-0 mb-0">
                              {{ employee.firstName + " " + employee.lastName }}
                            </h3>
                            <h6 class="text-muted">
                              {{ employee.designation && employee.designation.name }}
                            </h6>
                            <small class="text-muted">{{
                              employee.designation && employee.designation.department.name
                            }}</small>
                            <div class="staff-id">
                              Employee ID :
                              {{ employee.employeeCode }}
                            </div>
                            <div class="staff-id">
                              Business Unit :
                              {{ companyUnit.name }}
                            </div>
                            <div class="small doj text-muted">
                              Date of Join :
                              {{
                                employee.joinDate
                                  ? new Date(
                                      employee.joinDate
                                    ).toLocaleDateString()
                                  : ""
                              }}
                            </div>
                            <div class="small doj text-muted">
                              State :
                              {{ employee.state }}
                            </div>
                            <!-- <div class="staff-msg">
															<router-link to="/chat" class="btn btn-custom">Send Message
															</router-link>
														</div> -->
                          </div>
                        </div>
                        <div class="col-md-7">
                          <ul class="personal-info">
                            <li>
                              <div class="title">Phone:</div>
                              <div class="text">
                                {{ employee.phone }}
                              </div>
                            </li>
                            <li>
                              <div class="title">Email:</div>
                              <div class="text">
                                <a href="">{{ employee.email }}</a>
                              </div>
                            </li>
                            <li>
                              <div class="title">Birthday:</div>
                              <div class="text">
                                {{
                                  new Date(
                                    employee.birthday
                                  ).toLocaleDateString()
                                }}
                              </div>
                            </li>
                            <li>
                              <div class="title">Address:</div>
                              <div class="text">{{ employee.address }}</div>
                            </li>
                            <li>
                              <div class="title">Gender:</div>
                              <div class="text">{{ employee.gender }}</div>
                            </li>
                            <li>
                              <div class="title">Admin. Reports to:</div>
                              <div class="text" v-if="employee.employeeManager">
                                <div class="avatar-box">
                                  <div class="avatar avatar-xs">
                                    <img
                                      alt=""
                                      :src="
                                        media +
                                          employee.employeeManager.manager
                                            .passportPhoto
                                      "
                                      v-if="
                                        employee.employeeManager.manager
                                          .passportPhoto
                                      "
                                    />
                                    <img
                                      alt=""
                                      src="~@/assets/profiles/avatar-02.jpg"
                                      v-if="
                                        !employee.employeeManager.manager
                                          .passportPhoto
                                      "
                                    />
                                  </div>
                                </div>
                                <div>
                                  {{
                                    employee.employeeManager.manager.firstName +
                                      " " +
                                      employee.employeeManager.manager.lastName
                                  }}
                                </div>
                              </div>
                              <div class="text" v-else>
                                <div class="d-flex">
                                  <span class="">No Manager Assigned</span>
                                  
                                </div>
                              </div>
                            </li>
                            <li>
                              <div class="title">Admin. II Reports to:</div>
                              <div
                                class="text"
                                v-if="employee.employeeStage2Manager"
                              >
                                <div class="avatar-box">
                                  <div class="avatar avatar-xs">
                                    <img
                                      alt=""
                                      :src="
                                        media +
                                          employee.employeeStage2Manager.manager
                                            .passportPhoto
                                      "
                                      v-if="
                                        employee.employeeStage2Manager.manager
                                          .passportPhoto
                                      "
                                    />
                                    <img
                                      alt=""
                                      src="~@/assets/profiles/avatar-02.jpg"
                                      v-if="
                                        !employee.employeeStage2Manager.manager
                                          .passportPhoto
                                      "
                                    />
                                  </div>
                                </div>
                                <div>
                                  {{
                                    employee.employeeStage2Manager.manager
                                      .firstName +
                                      " " +
                                      employee.employeeStage2Manager.manager
                                        .lastName
                                  }}
                                </div>
                              </div>
                              <div class="text" v-else>
                                <div class="d-flex">
                                  <span class="">No Manager Assigned</span>
                                  
                                </div>
                              </div>
                            </li>
                            <li>
                              <div class="title">Expense Reports to:</div>
                              <div
                                class="text"
                                v-if="employee.operationalEmployeeManager"
                              >
                                <div class="avatar-box">
                                  <div class="avatar avatar-xs">
                                    <img
                                      alt=""
                                      :src="
                                        media +
                                          employee.operationalEmployeeManager
                                            .manager.passportPhoto
                                      "
                                      v-if="
                                        employee.operationalEmployeeManager
                                          .manager.passportPhoto
                                      "
                                    />
                                    <img
                                      alt=""
                                      src="~@/assets/profiles/avatar-02.jpg"
                                      v-if="
                                        !employee.operationalEmployeeManager
                                          .manager.passportPhoto
                                      "
                                    />
                                  </div>
                                </div>
                                <div>
                                  {{
                                    employee.operationalEmployeeManager.manager
                                      .firstName +
                                      " " +
                                      employee.operationalEmployeeManager
                                        .manager.lastName
                                  }}
                                </div>
                              </div>
                              <div class="text" v-else>
                                <div class="d-flex">
                                  <span class="">No Approver Assigned</span>
                                  
                                </div>
                              </div>
                            </li>
                            <li>
                              <div class="title">Expense II Reports to:</div>
                              <div
                                class="text"
                                v-if="employee.operationalEmployeeStage2Manager"
                              >
                                <div class="avatar-box">
                                  <div class="avatar avatar-xs">
                                    <img
                                      alt=""
                                      :src="
                                        media +
                                          employee
                                            .operationalEmployeeStage2Manager
                                            .manager.passportPhoto
                                      "
                                      v-if="
                                        employee
                                          .operationalEmployeeStage2Manager
                                          .manager.passportPhoto
                                      "
                                    />
                                    <img
                                      alt=""
                                      src="~@/assets/profiles/avatar-02.jpg"
                                      v-if="
                                        !employee
                                          .operationalEmployeeStage2Manager
                                          .manager.passportPhoto
                                      "
                                    />
                                  </div>
                                </div>
                                <div>
                                  {{
                                    employee.operationalEmployeeStage2Manager
                                      .manager.firstName +
                                      " " +
                                      employee.operationalEmployeeStage2Manager
                                        .manager.lastName
                                  }}
                                </div>
                              </div>
                              <div class="text" v-else>
                                <div class="d-flex">
                                  <span class="">No Approver Assigned</span>
                                  
                                </div>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div class="pro-edit">
                      <a
                        @click.prevent="openProfile"
                        v-if="myAccount"
                        class="edit-icon"
                        href="#"
                        ><i class="fa fa-pencil"></i
                      ></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="card tab-box">
            <div class="row user-tabs">
              <div class="col-lg-12 col-md-12 col-sm-12 line-tabs">
                <ul class="nav nav-tabs nav-tabs-bottom">
                  <li class="nav-item">
                    <a
                      href="#emp_profile"
                      data-toggle="tab"
                      class="nav-link active"
                      >Profile</a
                    >
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div class="tab-content">
            <!-- Profile Info Tab -->
            <div
              id="emp_profile"
              class="pro-overview tab-pane fade show active"
            >
              <div class="row">
                <div class="col-md-6 d-flex">
                  <div class="card profile-box flex-fill">
                    <div class="card-body">
                      <h3 class="card-title">
                        Personal Information
                        <a
                          href="#"
                          class="edit-icon"
                          v-if="myAccount"
                          @click.prevent="openPersonalInfo"
                          ><i class="fa fa-pencil"></i
                        ></a>
                      </h3>
                      <ul class="personal-info">
                        <li>
                          <div class="title">Passport No.</div>
                          <div class="text">
                            {{ employee.passportIdentificationNumber }}
                          </div>
                        </li>
                        <li>
                          <div class="title">Passport Exp Date.</div>
                          <div class="text">
                            {{
                              new Date(
                                employee.passportExpiryDate
                              ).toLocaleDateString()
                            }}
                          </div>
                        </li>
                        <li>
                          <div class="title">NIN</div>
                          <div class="text">
                            {{ employee.nationalIdentityNumber }}
                          </div>
                        </li>
                        <li>
                          <div class="title">Tel</div>
                          <div class="text">
                            <a href="">{{ employee.phone }}</a>
                          </div>
                        </li>
                        <li>
                          <div class="title">Nationality</div>
                          <div class="text">{{ employee.nationality }}</div>
                        </li>
                        <li>
                          <div class="title">Religion</div>
                          <div class="text">{{ employee.religion }}</div>
                        </li>
                        <li>
                          <div class="title">Marital status</div>
                          <div class="text">{{ employee.maritalStatus }}</div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="col-md-6 d-flex">
                  <div class="card profile-box flex-fill">
                    <div class="card-body">
                      <h3 class="card-title">
                        Emergency Contact
                        <a
                          href="#"
                          class="edit-icon"
                          v-if="myAccount"
                          @click.prevent="openEmergencyContact"
                          ><i class="fa fa-pencil"></i
                        ></a>
                      </h3>
                      <div v-if="employee.employeeEmergencies">
                        <div v-if="employee.employeeEmergencies.length > 0">
                          <h5 class="section-title">Primary</h5>
                          <ul class="personal-info">
                            <li>
                              <div class="title-label">Name</div>
                              <div class="text">
                                {{ employee.employeeEmergencies[0].name }}
                              </div>
                            </li>
                            <li>
                              <div class="title-label">Relationship</div>
                              <div class="text">
                                {{
                                  employee.employeeEmergencies[0].relationship
                                }}
                              </div>
                            </li>
                            <li>
                              <div class="title-label">Phone</div>
                              <div class="text">
                                {{
                                  employee.employeeEmergencies[0].phone1 +
                                    ", " +
                                    employee.employeeEmergencies[0].phone2
                                }}
                              </div>
                            </li>
                          </ul>
                          <hr />
                          <h5
                            class="section-title"
                            v-if="employee.employeeEmergencies.length > 1"
                          >
                            Secondary
                          </h5>
                          <ul
                            class="personal-info"
                            v-if="employee.employeeEmergencies.length > 1"
                          >
                            <li>
                              <div class="title-label">Name</div>
                              <div class="text">
                                {{ employee.employeeEmergencies[1].name }}
                              </div>
                            </li>
                            <li>
                              <div class="title-label">Relationship</div>
                              <div class="text">
                                {{
                                  employee.employeeEmergencies[1].relationship
                                }}
                              </div>
                            </li>
                            <li>
                              <div class="title-label">Phone</div>
                              <div class="text">
                                {{
                                  employee.employeeEmergencies[1].phone1 +
                                    ", " +
                                    employee.employeeEmergencies[1].phone2
                                }}
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6 d-flex">
                  <div class="card profile-box flex-fill">
                    <div class="card-body">
                      <h3 class="card-title">
                        Bank information
                        <a
                          href="#"
                          class="edit-icon"
                          v-if="employee.employeeBank == null"
                          @click.prevent="openBankInfo"
                          ><i class="fa fa-pencil"></i
                        ></a>
                        <a
                          href="#"
                          class="edit-icon"
                          v-if="employee.employeeBank"
                          @click.prevent="openBankInfoEdit"
                          ><i class="fa fa-pencil"></i
                        ></a>
                      </h3>
                      <ul class="personal-info" v-if="employee.employeeBank">
                        <li>
                          <div class="title-label">Bank name</div>
                          <div class="text">
                            {{
                              employee.employeeBank
                                ? employee.employeeBank.bankName
                                : ""
                            }}
                          </div>
                        </li>
                        <li>
                          <div class="title-label">Bank account No.</div>
                          <div class="text">
                            {{
                              employee.employeeBank
                                ? employee.employeeBank.bankAccountNumber
                                : ""
                            }}
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="col-md-6 d-flex">
                  <div class="card profile-box flex-fill">
                    <div class="card-body">
                      <h3 class="card-title">
                        Family Information
                        <a
                          href="#"
                          class="edit-icon"
                          v-if="myAccount"
                          @click.prevent="openFamilyInfo()"
                          ><i class="fa fa-pencil"></i
                        ></a>
                      </h3>
                      <div class="table-responsive">
                        <table class="table table-nowrap">
                          <thead>
                            <tr>
                              <th>Name</th>
                              <th>Relationship</th>
                              <th>Phone</th>
                              <th></th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="item in employee.employeeFamilies"
                              :key="item.id"
                            >
                              <td>{{ item.name }}</td>
                              <td>{{ item.relationship }}</td>
                              <td>{{ item.phoneNo }}</td>
                              <td class="text-right">
                                <div class="dropdown dropdown-action">
                                  <a
                                    aria-expanded="false"
                                    data-toggle="dropdown"
                                    class="action-icon dropdown-toggle"
                                    href="#"
                                    ><i class="material-icons">more_vert</i></a
                                  >
                                  <div
                                    class="dropdown-menu dropdown-menu-right"
                                  >
                                    <a
                                      class="dropdown-item"
                                      @click.prevent="openFamilyInfo(item)"
                                      ><i class="fa fa-pencil m-r-5"></i>
                                      Edit</a
                                    >
                                    <a
                                      class="dropdown-item"
                                      @click.prevent="
                                        OpenDeleteFamilyData(item)
                                      "
                                      ><i class="fa fa-trash-o m-r-5"></i>
                                      Delete</a
                                    >
                                  </div>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6 d-flex">
                  <div class="card profile-box flex-fill">
                    <div class="card-body">
                      <h3 class="card-title">
                        Education Information
                        <a
                          href="#"
                          class="edit-icon"
                          v-if="myAccount"
                          @click.prevent="openEducation()"
                          ><iç class="fa fa-pencil"></iç
                        ></a>
                      </h3>
                      <div class="experience-box">
                        <ul class="experience-list">
                          <li
                            v-for="item in employee.employeeEducations"
                            :key="item.id"
                          >
                            <div class="experience-user">
                              <div class="before-circle"></div>
                            </div>
                            <div class="experience-content">
                              <div class="timeline-content">
                                <a
                                  href="#"
                                  @click.prevent="openEducation(item)"
                                  class="name"
                                  >{{ item.institute }}</a
                                >
                                <div>{{ item.discipline }}</div>
                                <span class="time"
                                  >{{
                                    new Date(item.startYear).toLocaleString(
                                      "default",
                                      {
                                        month: "short"
                                      }
                                    )
                                  }}
                                  {{ new Date(item.startYear).getFullYear() }} -
                                  {{
                                    new Date(item.endYear).toLocaleString(
                                      "default",
                                      {
                                        month: "short"
                                      }
                                    )
                                  }}
                                  {{
                                    new Date(item.endYear).getFullYear()
                                  }}</span
                                >
                              </div>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6 d-flex">
                  <div class="card profile-box flex-fill">
                    <div class="card-body">
                      <h3 class="card-title">
                        Experience
                        <a
                          href="#"
                          class="edit-icon"
                          v-if="myAccount"
                          @click.prevent="openExperience()"
                          ><i class="fa fa-pencil"></i
                        ></a>
                      </h3>
                      <div class="experience-box">
                        <ul class="experience-list">
                          <li
                            v-for="item in employee.employeeExperiences"
                            :key="item.id"
                          >
                            <div class="experience-user">
                              <div class="before-circle"></div>
                            </div>
                            <div class="experience-content">
                              <div class="timeline-content">
                                <a
                                  href="#"
                                  @click.prevent="openExperience(item)"
                                  class="name"
                                  >{{ item.companyName }}</a
                                >
                                <span class="time"
                                  >{{
                                    new Date(item.startYear).toLocaleString(
                                      "default",
                                      {
                                        month: "short"
                                      }
                                    )
                                  }}
                                  {{ new Date(item.startYear).getFullYear() }} -
                                  {{
                                    new Date(item.endYear).toLocaleString(
                                      "default",
                                      {
                                        month: "short"
                                      }
                                    )
                                  }}
                                  {{
                                    new Date(item.endYear).getFullYear()
                                  }}</span
                                >
                              </div>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6 d-flex" v-if="profileNOK">
                  <div class="card profile-box flex-fill">
                    <div class="card-body">
                      <h3 class="card-title">
                        Next Of Kin Information
                        <a
                          href="#"
                          class="edit-icon"
                          v-if="myAccount"
                          @click="openNOK"
                          ><i class="fa fa-pencil"></i
                        ></a>
                      </h3>
                      <ul
                        class="personal-info"
                        v-if="employee.employeeNextOfKin"
                      >
                        <li>
                          <div class="title-label">Full Name</div>
                          <div class="text">
                            {{ employee.employeeNextOfKin.fullName }}
                          </div>
                        </li>
                        <li>
                          <div class="title-label">Address</div>
                          <div class="text">
                            {{ employee.employeeNextOfKin.address }}
                          </div>
                        </li>
                        <li>
                          <div class="title-label">Phone No.</div>
                          <div class="text">
                            {{ employee.employeeNextOfKin.phone }}
                          </div>
                        </li>
                        <li>
                          <div class="title-label">Relationship</div>
                          <div class="text">
                            {{ employee.employeeNextOfKin.relationship }}
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="col-md-6 d-flex" v-if="profileGLI">
                  <div class="card profile-box flex-fill">
                    <div class="card-body">
                      <h3 class="card-title">
                        Group Life Assurance Beneficiary Information
                        <a
                          href="#"
                          class="edit-icon"
                          v-if="myAccount"
                          @click="openGLI"
                          ><i class="fa fa-pencil"></i
                        ></a>
                      </h3>
                      <div class="table-responsive">
                        <table class="table table-nowrap">
                          <thead>
                            <tr>
                              <th>Name</th>
                              <th>Relationship</th>
                              <th>Percentage</th>
                              <th></th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="item in employee.employeeGLIs"
                              :key="item.id"
                            >
                              <td>{{ item.fullName }}</td>
                              <td>{{ item.relationship }}</td>
                              <td>{{ item.percentage }}%</td>
                              <td class="text-right">
                                <div class="dropdown dropdown-action">
                                  <a
                                    aria-expanded="false"
                                    data-toggle="dropdown"
                                    class="action-icon dropdown-toggle"
                                    href="#"
                                    ><i class="material-icons">more_vert</i></a
                                  >
                                  <div
                                    class="dropdown-menu dropdown-menu-right"
                                  >
                                    <a
                                      @click="openFamilyInfo"
                                      class="dropdown-item"
                                      ><i class="fa fa-pencil m-r-5"></i>
                                      Edit</a
                                    >
                                    <a href="#" class="dropdown-item"
                                      ><i class="fa fa-trash-o m-r-5"></i>
                                      Delete</a
                                    >
                                  </div>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- /Profile Info Tab -->
          </div>
        </div>
        <!-- /Page Content -->
        <!-- /Page Content -->
        <emergency-contact-modal
          :model="employee.employeeEmergencies"
          :id="currentUser.employee.id"
          :dialog="emergencyContactDialog"
          v-if="emergencyContactDialog"
          :method="closeEmergencyContact"
        ></emergency-contact-modal>
        <personal-info-modal
          :model="employee"
          :dialog="personalInfoDialog"
          v-if="personalInfoDialog"
          :method="closePersonalInfo"
        ></personal-info-modal>
        <profile-modal
          :model="employee"
          :dialog="profileDialog"
          v-if="profileDialog"
          :method="closeProfile"
        ></profile-modal>
        <!-- <bank-info-modal
          :model="employee.employeeBank"
          :id="currentUser.employee.id"
          :dialog="bankInfoDialog"
          v-if="bankInfoDialog"
          :method="closeBankInfo"
        ></bank-info-modal> -->
        <family-info-modal
          :model="familyModelToEdit"
          :id="currentUser.employee.id"
          :dialog="familyInfoDialog"
          v-if="familyInfoDialog"
          :method="closeFamilyInfo"
        ></family-info-modal>
        <experience-modal
          :model="experienceModelToEdit"
          :id="currentUser.employee.id"
          :dialog="experienceDialog"
          v-if="experienceDialog"
          :method="closeExperience"
        ></experience-modal>
        <education-modal
          :model="educationModelToEdit"
          :id="currentUser.employee.id"
          :dialog="educationDialog"
          v-if="educationDialog"
          :method="closeEducation"
        ></education-modal>
        <nextOfKin-modal
          :model="employee.employeeNextOfKin"
          :id="this.$route.params.id"
          :dialog="nextOfKinDialog"
          v-if="nextOfKinDialog"
          :method="closeNOK"
        ></nextOfKin-modal>
        <gli-modal
          :model="employee.employeeGLIs"
          :id="this.$route.params.id"
          :dialog="gliDialog"
          v-if="gliDialog"
          :method="closeGLI"
        ></gli-modal>
        <v-dialog v-model="changePhotodialog" max-width="230px">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Change Photo</h5>
              <button type="button" class="close" @click="closeChangePhoto">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="col-md-12">
                <img alt="" :src="file" width="200" />
              </div>
              <div class="col-md-12">
                <button class="btn btn-info" @click="handleFileUpload">
                  Change Photo
                </button>
                <input
                  type="file"
                  style="display: none"
                  ref="file"
                  accept="image/*"
                  @change="onFilePicked"
                />
              </div>
            </div>
          </div>
        </v-dialog>

        <v-dialog v-model="bankInfoDialog" max-width="725px">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Bank Information</h5>
              <button type="button" class="close" @click="closeBankInfo">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form @submit.prevent="postBank">
                <div class="form-scroll">
                  <div class="card">
                    <div class="card-body">
                      <h3 class="card-title">Bank Information</h3>
                      <div class="row">
                        <div class="col-md-12">
                          <div
                            class="alert alert-danger alert-dismissible fade show"
                            role="alert"
                            v-if="error"
                          >
                            <strong>Error!</strong> {{ error }}
                            <button
                              type="button"
                              class="close"
                              data-dismiss="alert"
                              aria-label="Close"
                            >
                              <span aria-hidden="true">&times;</span>
                            </button>
                          </div>
                        </div>
                        <div class="col-md-12">
                          <div
                            class="alert alert-success alert-dismissible fade show"
                            role="alert"
                            v-if="message"
                          >
                            <strong>Success!</strong> {{ message }}
                            <button
                              type="button"
                              class="close"
                              data-dismiss="alert"
                              aria-label="Close"
                            >
                              <span aria-hidden="true">&times;</span>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group">
                            <label
                              >Account Number
                              <span class="text-danger">*</span></label
                            >
                            <input
                              class="form-control"
                              v-model.trim="$v.bankAccountNumber.$model"
                              type="text"
                            />
                          </div>
                          <div
                            v-if="submitted && !$v.bankAccountNumber.required"
                            class="invalid-feedback"
                          >
                            Account Number is required
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group">
                            <label
                              >Bank Name
                              <span class="text-danger">*</span></label
                            >

                            <multiselectvue
                              class="from-control"
                              v-model="selectedBank"
                              placeholder="Select Bank"
                              :custom-label="nameOfDesignation"
                              :options="banks"
                              :searchable="true"
                              @select="optionSelectDesignation"
                              :allow-empty="false"
                            >
                              <template
                                slot="singleLabel"
                                slot-scope="{ option }"
                                >{{ option.lookupDescription }}</template
                              >
                            </multiselectvue>
                          </div>
                        </div>
                        <!-- <div class="col-md-12">
                          <div class="form-group">
                            <label
                              >Bank Verification Number
                              <span class="text-danger">*</span></label
                            >
                            <input
                              class="form-control"
                              v-model.trim="$v.bvnNumber.$model"
                              type="text"
                            />
                          </div>
                          <div
                            v-if="submitted && !$v.bvnNumber.required"
                            class="invalid-feedback"
                          >
                            Bank Verification Number is required
                          </div>
                        </div> -->
                      </div>
                    </div>
                  </div>
                </div>
                <div class="submit-section">
                  <button class="btn btn-primary submit-btn" type="submit">
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </v-dialog>
        <!-- /Family Info Modal -->

        <v-dialog v-model="bankInfoDialogEdit" max-width="725px">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Bank Information</h5>
              <button type="button" class="close" @click="closeBankInfo">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form @submit.prevent="upDateBank">
                <div class="form-scroll">
                  <div class="card">
                    <div class="card-body">
                      <h3 class="card-title">Bank Information</h3>
                      <div class="row">
                        <div class="col-md-12">
                          <div
                            class="alert alert-danger alert-dismissible fade show"
                            role="alert"
                            v-if="error"
                          >
                            <strong>Error!</strong> {{ error }}
                            <button
                              type="button"
                              class="close"
                              data-dismiss="alert"
                              aria-label="Close"
                            >
                              <span aria-hidden="true">&times;</span>
                            </button>
                          </div>
                        </div>
                        <div class="col-md-12">
                          <div
                            class="alert alert-success alert-dismissible fade show"
                            role="alert"
                            v-if="message"
                          >
                            <strong>Success!</strong> {{ message }}
                            <button
                              type="button"
                              class="close"
                              data-dismiss="alert"
                              aria-label="Close"
                            >
                              <span aria-hidden="true">&times;</span>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group">
                            <label
                              >Account Number
                              <span class="text-danger">*</span></label
                            >
                            <input
                              v-if="
                                employee.employeeBank
                                  ? employee.employeeBank.bankAccountNumber
                                  : ''
                              "
                              class="form-control"
                              v-model="employee.employeeBank.bankAccountNumber"
                              type="text"
                            />
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group">
                            <label
                              >Bank Name
                              <span class="text-danger">*</span></label
                            >

                            <!-- <multiselectvue
                              class="from-control"
                              v-model="employee.employeeBank.bankName"
                              placeholder="Select Bank"
                              :custom-label="nameOfDesignationEdit"
                              :options="banks"
                              :searchable="true"
                              @select="optionSelectDesignationEdit"
                              :allow-empty="false"
                            >
                              <template
                                slot="singleLabel"
                                slot-scope="{ option }"
                                >{{ option.lookupDescription }}</template
                              >
                            </multiselectvue> -->

                            <select
                              class="form-control"
                              v-if="
                                employee.employeeBank
                                  ? employee.employeeBank.bankName
                                  : ''
                              "
                              v-model="employee.employeeBank.bankName"
                            >
                              <option>Select Bank</option>
                              <option
                                v-for="item in banks"
                                :key="item.lookupValue"
                                :value="item.lookupDescription"
                              >
                                {{ item.lookupDescription }}
                              </option>
                            </select>
                          </div>
                        </div>
                        <!-- <div class="col-md-12">
                          <div class="form-group">
                            <label
                              >Bank Verification Number
                              <span class="text-danger">*</span></label
                            >
                            <input
                              v-if="
                                employee.employeeBank
                                  ? employee.employeeBank.bvnNumber
                                  : ''
                              "
                              class="form-control"
                              v-model="employee.employeeBank.bvnNumber"
                              type="text"
                            />
                          </div>
                        </div> -->
                      </div>
                    </div>
                  </div>
                </div>
                <div class="submit-section">
                  <button class="btn btn-primary submit-btn" type="submit">
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </v-dialog>
        <!-- /Family Info Modal -->

        <!-- Delete Family Modal -->
        <v-dialog v-model="dialogDeleteFamily" max-width="725px">
          <div class="modal-content">
            <div class="modal-body">
              <div class="form-header">
                <button type="button" class="close" @click="closeDelete">
                  <span aria-hidden="true">&times;</span>
                </button>
                <div
                  class="alert alert-success alert-dismissible fade show"
                  role="alert"
                  v-if="message"
                >
                  <strong>Success!</strong> {{ message }}
                  <button
                    type="button"
                    class="close"
                    data-dismiss="alert"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>

                <h3>Delete Family</h3>
                <p>Are you sure want to delete?</p>
              </div>
              <div class="modal-btn delete-action">
                <div class="row">
                  <div class="col-6">
                    <a
                      @click.prevent="deleteFamilyInfo"
                      class="btn btn-primary continue-btn"
                      data-dismiss="modal"
                      >Delete</a
                    >
                  </div>
                  <div class="col-6">
                    <a
                      href="javascript:void(0);"
                      data-dismiss="modal"
                      @click="closeDelete"
                      class="btn btn-primary cancel-btn"
                      >Cancel</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-dialog>
        <!-- /Delete family Modal -->
      </div>
      <!-- /Page Wrapper -->
    </div>
  </div>
</template>

<script>
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";
import LayoutSidebarHR from "@/components/layouts/Sidebar.vue";
import PersonalInfoModal from "@/components/employees/PersonalInfoModal.vue";
import ProfileModal from "@/components/employees/ProfileModal.vue";
import FamilyInfoModal from "@/components/employees/FamilyInfoModal.vue";
import BankInfoModal from "@/components/employees/BankInfoModal.vue";
import ExperienceModal from "@/components/employees/ExperienceModal.vue";
import EducationModal from "@/components/employees/EducationModal.vue";
import GLIModal from "@/components/employees/GLIModal.vue";
import NextOfKinInfoModal from "@/components/employees/NextOfKinInfoModal.vue";
import EmergencyContactModal from "@/components/employees/EmergencyContactModal.vue";
import { required, sameAs } from "vuelidate/lib/validators";
import { employeeService } from "@/services/employeeService.js";
import { authenticationService } from "@/services/authenticationService";
import { organizationService } from "@/services/organizationService";
export default {
  components: {
    LayoutHeader,
    LayoutSidebar,
    LayoutSidebarHR,
    PersonalInfoModal,
    ProfileModal,
    ExperienceModal,
    EducationModal,
    FamilyInfoModal,
    BankInfoModal,
    GLIModal,
    NextOfKinInfoModal,
    EmergencyContactModal
  },
  data() {
    return {
      changePhotodialog: false,
      submitted: false,
      experienceDialog: false,
      profileDialog: false,
      personalInfoDialog: false,
      dialogDeleteFamily: false,
      familyInfoDialog: false,
      familyModelToEdit: {},
      editFamilyInfoDialog: false,
      bankInfoDialog: false,
      bankInfoDialogEdit: false,
      educationDialog: false,
      gliDialog: false,
      nextOfKinDialog: false,
      emergencyContactDialog: false,
      message: "",
      error: "",
      company: authenticationService.currentOfficeValue,
      currentUser: authenticationService.currentUserValue,
      file: null,
      media: "data:image/jpeg;base64,",
      myAccount: true,
      profileGLI: false,
      companyUnit: null,
      profileNOK: false,
      requireUpdate: false,
      selectedBank: "",
      checkingBank: "",
      employee: {
        firstName: null,
        gender: "",
        id: authenticationService.currentUserValue.employee.id,
        lastName: "",
        maritalStatus: null,
        nationality: null,
        passportIdentificationNumber: null,
        passportPhoto: null,
        phone: "",
        religion: null,
        employeeBank: {},
        employeeEducations: [],
        educationModelToEdit: {},
        experienceModelToEdit: {},
        employeeEmergencies: [],
        employeeExperiences: [],
        employeeFamilies: []
      },
      bankDetails: {},
      banks: [],
      bankAccountNumber: "",
      bankCode: "",
      bankName: "",
      bvnNumber: "",
      family: {}
    };
  },
  validations: {
    bankAccountNumber: { required }
    // bvnNumber: { required }
  },
  watch: {
    requireUpdate(val) {
      if (val) this.GetEmployeeOtherDetails();
    }
  },
  mounted() {
    if (this.currentUser) {
      this.getAccountSetting();
      this.GetEmployee();
      this.getBanks();
      this.GetEmployeeOtherDetails();
    } else {
      // console.log(this.currentUser)
      //this.$route.push('/employees')
    }

    this.companyUnit = JSON.parse(localStorage.getItem("companyUnit"));
    // Date Time Picker

    if ($(".datetimepicker").length > 0) {
      $(".datetimepicker").datetimepicker({
        format: "DD/MM/YYYY",
        icons: {
          up: "fa fa-angle-up",
          down: "fa fa-angle-down",
          next: "fa fa-angle-right",
          previous: "fa fa-angle-left"
        }
      });
    }

    // Select 2
    if ($(".select").length > 0) {
      $(".select").select2({
        minimumResultsForSearch: -1,
        width: "100%"
      });
    }
    // Multiselect
    if ($("#customleave_select").length > 0) {
      $("#customleave_select").multiselect();
    }
    if ($("#edit_customleave_select").length > 0) {
      $("#edit_customleave_select").multiselect();
    }
    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function(e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }

    console.log(this.employee);
  },
  methods: {
    deleteFamilyInfo() {
      employeeService.removeEmployeeFamily(this.family.id).then(() => {
        this.message = "Family delete successfully!";
        this.GetEmployeeOtherDetails();
        this.closeDelete();
        this.GetEmployee();
      });
    },
    OpenDeleteFamilyData(item) {
      this.family = item;
      this.dialogDeleteFamily = true;
    },
    closeDelete() {
      this.dialogDelete = false;
      this.dialogDeleteFamily = false;
      this.clearData();
    },

    nameOfDesignation({ lookupDescription }) {
      return `${lookupDescription}`;
    },

    optionSelectDesignation(option, id) {
      console.log(option);
      this.bankName = option.lookupDescription;
      this.bankCode = option.lookupValue;
    },
    // nameOfDesignationEdit({ lookupDescription }) {
    //   return `${lookupDescription}`;
    // },

    // optionSelectDesignationEdit(option, id) {
    //   console.log(option);
    //   this.employee.employeeBank.bankName = option.lookupDescription;
    //   this.employee.employeeBank.bankCode = option.lookupValue;
    // },

    openProfile() {
      this.profileDialog = true;
      this.requireUpdate = false;
    },
    openPersonalInfo() {
      this.personalInfoDialog = true;
      this.requireUpdate = false;
    },
    openBankInfo() {
      this.bankInfoDialog = true;
      this.requireUpdate = false;
    },

    openBankInfoEdit() {
      this.bankInfoDialogEdit = true;
      this.requireUpdate = false;
    },
    openEducation(EducationInfo) {
      this.educationModelToEdit = EducationInfo == null ? {} : EducationInfo;
      this.educationDialog = true;
      this.requireUpdate = false;
    },
    openGLI() {
      this.gliDialog = true;
      this.requireUpdate = false;
    },
    openNOK() {
      this.nextOfKinDialog = true;
      this.requireUpdate = false;
    },
    openEmergencyContact() {
      this.emergencyContactDialog = true;
      this.requireUpdate = false;
    },
    openExperience(ExperienceInfo) {
      console.log(ExperienceInfo);
      this.experienceModelToEdit = ExperienceInfo == null ? {} : ExperienceInfo;
      this.experienceDialog = true;
      this.requireUpdate = false;
    },
    openFamilyInfo(familyInfo) {
      this.familyModelToEdit = familyInfo == null ? {} : familyInfo;
      this.familyInfoDialog = true;
      this.requireUpdate = false;
    },
    openChangePhoto() {
      this.changePhotodialog = true;
    },

    closeProfile(employee) {
      if (employee) this.employee = employee;
      this.profileDialog = false;
      this.requireUpdate = true;
    },
    closePersonalInfo(employee) {
      if (employee) this.employee = employee;
      this.personalInfoDialog = false;
      this.requireUpdate = true;
    },

    clearData() {
      this.message = "";
      this.error = "";
    },
    closeBankInfo() {
      // if (employee) this.employee = employee;
      this.bankInfoDialog = false;
      this.bankInfoDialogEdit = false;
      this.requireUpdate = true;
      this.clearData();
    },
    closeEducation(employee) {
      if (employee) this.employee = employee;
      this.educationDialog = false;
      this.requireUpdate = true;
    },
    closeGLI(employee) {
      if (employee) this.employee = employee;
      this.gliDialog = false;
      this.requireUpdate = true;
    },
    closeNOK(employee) {
      if (employee) this.employee = employee;
      this.nextOfKinDialog = false;
      this.requireUpdate = true;
    },
    closeEmergencyContact(employee) {
      if (employee) this.employee = employee;
      this.emergencyContactDialog = false;
      this.requireUpdate = true;
    },
    closeExperience(employee) {
      if (employee) this.employee = employee;
      this.experienceDialog = false;
      this.requireUpdate = true;
    },
    closeFamilyInfo(employee) {
      if (employee) this.employee = employee;
      this.familyInfoDialog = false;
      this.requireUpdate = true;
    },
    closeChangePhoto() {
      this.changePhotodialog = false;
    },
    handleFileUpload() {
      this.$refs.file.click();
    },
    getAccountSetting() {
      organizationService.getAccountSetting(this.company.id).then(o => {
        (this.profileNOK = o.profileNOK), (this.profileGLI = o.profileGLI);
      });
    },
    onFilePicked(event) {
      const files = event.target.files;
      let filename = files[0].name;
      const fileReader = new FileReader();
      fileReader.addEventListener("load", () => {
        this.file = fileReader.result;
      });
      fileReader.readAsDataURL(files[0]);
      this.file = files[0];
      employeeService.changeEmployeePhoto(files[0], this.employee.id).then(
        m => {
          this.employee = m;
          this.closeChangePhoto();

          console.log(m);
        },
        e => (this.imageError = e.title)
      );
    },
    GetEmployee() {
      employeeService.getEmployeeDetail(this.employee.id).then(
        model => {
          this.employee = model;
          if(this.employee.employeeBank == null){
            this.employee.employeeBank = {
              id: 0,
              bankName: '',
              bankAccountNumber: '',
              bankCode: ''
            }
          }
          this.employee.employeePension = {
            id: 0,
            pensionNo: "",
            employeeRate: "0",
            pensionManager: ""
          };
          this.employee.employeeStatutory = {
            id: 0,
            salaryBasis: "",
            salaryAmount: 0.0
          };
          this.employee.employeeTax = {
            id: 0,
            tin: "",
            taxCode: "",
            taxOffice: "",
            tax: {}
          };
          this.GetEmployeeOtherDetails();
        },
        error => {
          this.error = error;
        }
      );
    },

    postBank() {
      this.submitted = true;

      console.log(
        this.bankAccountNumber,
        this.bankCode,
        this.bankName,
        this.bvnNumber,
        this.employee.id
      );

      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      employeeService
        .addEmployeeBank(
          this.employee.id,
          this.bankAccountNumber,
          this.bankCode,
          this.bankName,
          this.bvnNumber
        )
        .then(
          model => {
            this.message = "Bank Info create successfully!";
            this.closeBankInfo();
            this.GetEmployeeOtherDetails();
            employeeService.getEmployeeDetail(this.employee.id).then(
              model => {
                this.employee = model;
              },
              error => {
                this.error = error;
              }
            );
          },
          error => {
            this.error = error;
          }
        );
    },

    upDateBank() {
      console.log(this.employee.employeeBank);
      let id = this.employee.employeeBank.id;
      employeeService.updateEmployeeBank(id, this.employee.employeeBank).then(
        model => {
          this.message = "Bank Info update successfully!";
          this.closeBankInfo();
          employeeService.getEmployeeDetail(this.employee.id).then(
            model => {
              this.employee = model;
            },
            error => {
              this.error = error;
            }
          );
        },
        error => {
          this.error = error;
        }
      );
    },

    getBanks() {
      organizationService.getBanks().then(o => (this.banks = o));
    },
    GetEmployeeOtherDetails() {
      employeeService.getEmployeeOtherDetail(this.employee.id).then(
        model => {
          this.bankDetails = model.employeeBank;
          this.employee.employeeBank = model.employeeBank;
          this.employee.employeeTax = model.employeeTax;
          this.employee.employeePension = model.employeePension;
          this.employee.employeeStatutory = model.employeeStatutory;
          this.employee.employeeEducations = model.employeeEducations;
          this.employee.employeeExperiences = model.employeeExperiences;
          this.employee.employeeEmergencies = model.employeeEmergencies;
          this.employee.employeeFamilies = model.employeeFamilies;
          this.employee.employeeGLIs = model.employeeGLIs;
          this.employee.employeeHMO = model.employeeHMO;
          this.employee.employeeNextOfKin = model.employeeNextOfKin;

          if (!this.employee.employeePension) {
            this.employee.employeePension = {
              id: 0,
              pensionNo: "",
              employeeRate: "0",
              pensionManager: ""
            };
          } else {
            this.employee.employeePension.employeeRate = model.employeePension.employeeRate.toString();
          }
          if (!this.employee.employeeStatutory) {
            this.employee.employeeStatutory = {
              id: 0,
              salaryBasis: "",
              salaryAmount: 0.0
            };
          }
          if (!this.employee.employeeTax) {
            this.employee.employeeTax = {
              id: 0,
              tin: "",
              taxCode: "",
              taxOffice: "",
              tax: {}
            };
          } else {
            this.employee.employeeTax.tax = {
              taxOffice: this.employee.employeeTax.taxCode,
              description: this.employee.employeeTax.taxOffice
            };
          }
        },
        error => {
          this.error = error;
        }
      );
    }
  },
  name: "profile"
};
</script>



// WEBPACK FOOTER //
// src/components/employees/profile.vue